<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text class="pa-4" style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <SectionSettingsContainerFuild
          class="mb-4"
          :settings="fields.settings"
          :container-page="fields.containerPage"
          :show-container-page="false"
          :show-background-image="false"
        />

        <div class="mb-4">
          <label class="label-input">Content</label>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.content" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Awards</label>
          <div class="group-item">
            <p class="mb-2 font-weight-bold">Innovation</p>
            <ckeditor :editor="editor" v-model="fields.awards.innovation" :config="editorConfig" />
            <p class="mt-4 mb-2 font-weight-bold">TikTok Hot</p>
            <ckeditor :editor="editor" v-model="fields.awards.tiktokHot" :config="editorConfig" />
          </div>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update.js';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

export default {
  name: 'furnitureshop-reward-section-editor',
  components: { SectionSettingsContainerFuild },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Furnitureshop reward',
        enableAnchor: false,
        settings: {
          paddingTop: false,
          paddingBottom: false,
          backgroundColor: '#010101',
          textColor: '#1b1b1b',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
          useBackgroundMobile: false,
          backgroundImageMobile: '',
        },
        containerPage: { enableStyle: false, background: '#FFFFFF' },
        content: '',
        awards: {
          innovation: '',
          tiktokHot: '',
        },
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(value) {
        if (value && value.sectionExtract) this.applyExtract(value.sectionExtract);
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        awards: { ...this.fields.awards, ...(extract.awards || {}) },
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const html = updateHtmlFromData.sectionFurnitureshopReward(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', { ...this.sectionEditor.section, title: this.fields.title, html });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
}
.label-input {
  display: block;
  margin-bottom: 10px;
  color: #000;
  font-size: 18px !important;
  font-weight: 500;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  padding: 0 16px;
  background-color: #fff;
  box-shadow: 0 0 12px #0000000f;
}
.footer-modal {
  position: sticky;
  bottom: 0;
  left: 0;
  z-index: 999;
  padding: 0 16px;
  background-color: #fff;
  box-shadow: 0 0 12px #0000000f;
}
</style>
